const baseSize = 16

// 设置 rem 函数
function setRem() {
    // 当前页面宽度相对于 1920宽的缩放比例，可根据自己需要修改。
    const wScale = document.documentElement.clientWidth / 1920
    const hScale = document.documentElement.clientHeight / 1080
    const rate = 1920 / 1080
    const rate1 = document.documentElement.clientWidth / document.documentElement.clientHeight
    let scale = 0
    if (rate >= rate1) {
        scale = wScale
    } else {
        scale = hScale
    }
    // const scale = Math.min(wScale, hScale)
    console.log(wScale, hScale, rate)
    // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
    // document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
    document.documentElement.style.fontSize = baseSize * scale + 'px'
}

// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.onresize = function () {
    setRem()
}
